"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import { usePathname } from "next/navigation"
import { useReactiveVar } from "@apollo/client/react"
import { isSigningInVar } from "../graphql/reactiveVars"
import useSessionAttributes from "../lib/auth/useSessionAttributes"

export default function useNavigationRequests() {
  const session = useSessionAttributes()
  const pathname = usePathname()
  const signingIn = useReactiveVar(isSigningInVar)
  const onLogin = pathname === "/login" || pathname?.startsWith("/login/")
  return {
    ...session,
    enabled: session.isAuthenticated && !onLogin && !signingIn,
  }
}
